// 会员信息管理 -- 查看会员
<template>
  <div class="look-member">
    <div>
      <!-- 头部组件 -->
      <!-- 使用组件 -->
      <MemberInfo></MemberInfo>
    </div>
    <div class="header-centers">
      <div class="left-member-box">
        <img
            v-if="expiredFlag"
            class="expired-img"
            src="../../../assets/image/expired.jpg"
            alt=""
        />
        <!-- 左侧会员基本信息 -->
        <el-card shadow="never" class="NumberCardWidth">
          <el-tabs v-model="activeName" stretch>
            <el-tab-pane label="基础信息" name="first">
              <div style="padding: 0 50px">
                <el-form
                    size="small"
                    label-width="120px"
                    :label-position="labelPosition"
                    :model="MemberInformation"
                >
                  <el-row :gutter="200">
                    <el-col :span="12">
                      <el-form-item label="客户姓">
                        <el-input
                            readonly
                            v-model="MemberInformation.lastName"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="客户名">
                        <el-input
                            readonly
                            v-model="MemberInformation.firstName"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="200">
                    <el-col :span="12">
                      <el-form-item label="会员等级">
                        <el-input
                            readonly
                            v-model="MemberInformation.levelNameCn"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="会员卡号">
                        <el-input
                            readonly
                            v-model="MemberInformation.cardNo"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="200">
                    <el-col :span="12">
                      <el-form-item label="维护店">
                        <el-input
                            readonly
                            v-model="MemberInformation.serviceOrgCode"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="当前维护人">
                        <el-input
                            readonly
                            v-model="MemberInformation.serviceEmpName"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="200">
                    <el-col :span="12">
                      <el-form-item label="性别">
                        <el-input
                            readonly
                            v-model="MemberInformation.gender"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="出生日期">
                        <el-date-picker
                            readonly
                            style="width: 100%"
                            v-model="MemberInformation.birthday"
                            type="date"
                        ></el-date-picker>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="200">
                    <el-col :span="12">
                      <el-form-item label="移动电话">
                        <el-input
                            readonly
                            v-model="MemberInformation.mobile"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="电子邮件">
                        <el-input
                            readonly
                            v-model="MemberInformation.userEmail"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="200">
                    <el-col :span="12">
                      <el-form-item label="电话">
                        <el-input
                            readonly
                            v-model="MemberInformation.telCode"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="行业">
                        <el-input
                            readonly
                            v-model="MemberInformation.industryName"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="200">
                    <el-col :span="12">
                      <el-form-item label="国家或地区">
                        <el-input
                            readonly
                            v-model="MemberInformation.countryNameCn"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="省">
                        <el-input
                            readonly
                            v-model="MemberInformation.stateNameCn"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="200">
                    <el-col :span="12">
                      <el-form-item label="市">
                        <el-input
                            readonly
                            v-model="MemberInformation.cityNameCn"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="通讯地址">
                        <el-input
                            readonly
                            v-model="MemberInformation.mailAddress"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="200">
                    <el-col :span="12">
                      <el-form-item label="常住地址">
                        <el-input
                            readonly
                            v-model="MemberInformation.permanentAddress"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="小程序OpenID">
                        <el-input
                            readonly
                            v-model="MemberInformation.weChatOpenID"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="200">
                    <el-col :span="12">
                      <el-form-item label="UnionID">
                        <el-input
                            readonly
                            v-model="MemberInformation.unionID"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item>
                        <el-checkbox
                            disabled
                            v-model="MemberInformation.custType"
                            label="VIC会员"
                        ></el-checkbox>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="200">
                    <el-col :span="12">
                      <el-form-item label="涉及业务">
                        <el-input
                            readonly
                            v-model="busskind"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                    </el-col>
                  </el-row>
                </el-form>
              </div>
            </el-tab-pane>
            <el-tab-pane label="会员补充信息" name="second">
              <div style="padding: 0 50px">
                <el-form
                    size="small"
                    label-width="150px"
                    :label-position="labelPosition"
                    :model="MemberInformation"
                >
                  <el-row :gutter="200">
                    <el-col :span="12">
                      <el-form-item label="注册门店">
                        <el-input
                            readonly
                            v-model="MemberInformation.registOrgCode"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="注册日期">
                        <el-date-picker
                            readonly
                            style="width: 100%"
                            v-model="MemberInformation.registDate"
                            type="date"
                        ></el-date-picker>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="200">
                    <el-col :span="12">
                      <el-form-item label="最新升级门店">
                        <el-input
                            readonly
                            v-model="MemberInformation.updateLvlOrgCode"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="最新升级日期">
                        <el-date-picker
                            readonly
                            style="width: 100%"
                            v-model="MemberInformation.updateLvlDate"
                        ></el-date-picker>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="200">
                    <el-col :span="12">
                      <el-form-item label="首次升级VIC门店">
                        <el-input
                            readonly
                            v-model="MemberInformation.firstVipOrgCode"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="首次升级VIC日期">
                        <el-date-picker
                            readonly
                            style="width: 100%"
                            v-model="MemberInformation.firstVipDate"
                        ></el-date-picker>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="200">
                    <el-col :span="12">
                      <el-form-item label="保级起始日期">
                        <el-date-picker
                            readonly
                            style="width: 100%"
                            v-model="MemberInformation.lvlStartDate"
                        ></el-date-picker>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="保级终止日期">
                        <el-date-picker
                            readonly
                            style="width: 100%"
                            v-model="MemberInformation.lvlExpireDate"
                        ></el-date-picker>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="200">
                    <el-col :span="12">
                      <el-form-item label="当前保级消费总金额">
                        <el-input
                            readonly
                            style="width: 100%"
                            v-model="MemberInformation.lvlAmount"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="当前可能降级级别">
                        <el-input
                            readonly
                            v-model="MemberInformation.canDegradeName"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="200">
                    <el-col :span="12">
                      <el-form-item label="会员来源">
                        <el-input
                            readonly
                            style="width: 100%"
                            v-model="MemberInformation.custSourceName"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item>
                        <el-checkbox
                            name="type"
                            label="保级成功"
                            disabled
                            v-model="MemberInformation.hasRelegation"
                        ></el-checkbox>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="200">
                    <el-col :span="12">
                      <el-form-item label="会员来源-备注">
                        <el-input
                            readonly
                            style="width: 100%"
                            v-model="MemberInformation.custSourceNotes"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item>
                        <el-checkbox
                            disabled
                            v-model="MemberInformation.isMillVIP"
                            label="商场VIP"
                        ></el-checkbox>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="200">
                    <el-col :span="12">
                      <el-form-item label="会员TAG">
                        <textarea
                            name=""
                            id=""
                            rows="6"
                            readonly
                            class="textareaClass"
                            v-model="checkBoxText.MemberTag"
                        ></textarea>
                      </el-form-item>
                    </el-col>

                    <el-col :span="12">
                      <el-form-item label="推荐人">
                        <el-input
                            readonly
                            style="width: 100%"
                            v-model="MemberInformation.referrerName"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="200">
                    <el-col :span="12">
                      <el-form-item label="联系方式添加情况">
                        <el-input
                            readonly
                            style="width: 100%"
                            v-model="checkBoxText.contactInfo"
                        ></el-input>
                      </el-form-item>
                    </el-col>

                    <el-col :span="12">
                      <el-form-item label="会员活跃度">
                        <el-input
                            readonly
                            style="width: 100%"
                            v-model="checkBoxText.activityLevel"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </div>
            </el-tab-pane>
            <el-tab-pane label="积分信息" name="third">
              <div style="padding: 0 50px">
                <el-form
                    size="small"
                    label-width="160px"
                    :label-position="labelPosition"
                    :model="MemberInformation"
                >
                  <el-row :gutter="200">
                    <el-col :span="24">
                      <el-form-item label="当前可用总积分">
                        <el-input
                            readonly
                            v-model="MemberInformation.availPointAll"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="消费当前可用积分">
                        <el-input
                            readonly
                            v-model="MemberInformation.availPoint"
                        ></el-input>
                      </el-form-item>
                    </el-col>

                    <el-col :span="12">
                      <el-form-item label="GF当前可用积分">
                        <el-input
                            readonly
                            v-model="MemberInformation.gfAvailPoint"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="待取消积分">
                        <el-input
                            readonly
                            style="width: 100%"
                            v-model="MemberInformation.loseEfficacyPoints"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="GF待取消积分">
                        <el-input
                            readonly
                            v-model="MemberInformation.gfLoseEfficacyPoints"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="今年累计积分">
                        <el-input
                            readonly
                            style="width: 100%"
                            v-model="MemberInformation.currYearPoints"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="去年累积积分">
                        <el-input
                            readonly
                            style="width: 100%"
                            v-model="MemberInformation.preYearPoints"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="总累积积分">
                        <el-input
                            readonly
                            style="width: 100%"
                            v-model="MemberInformation.allPoints"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="待生效积分">
                        <el-input
                            readonly
                            style="width: 100%"
                            v-model="MemberInformation.pendingPoints"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="今年已使用积分">
                        <el-input
                            readonly
                            style="width: 100%"
                            v-model="MemberInformation.currExchangePoints"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="去年已使用积分">
                        <el-input
                            readonly
                            style="width: 100%"
                            v-model="MemberInformation.prevExchangePoints"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </div>
            </el-tab-pane>
            <el-tab-pane label="消费信息" name="fourth">
              <div style="padding: 0 50px">
                <el-form
                    readonly
                    size="small"
                    label-width="150px"
                    :label-position="labelPosition"
                    :model="MemberInformation"
                >
                  <el-row :gutter="200">
                    <el-col :span="12">
                      <el-form-item label="今年消费额">
                        <el-input
                            readonly
                            v-model="MemberInformation.currYearAmount"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="平均客单价">
                        <el-input
                            readonly
                            style="width: 100%"
                            v-model="MemberInformation.avgSheetAmt"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="今年消费次数合计">
                        <el-input
                            readonly
                            style="width: 100%"
                            v-model="MemberInformation.currYearSaleTimes"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="Top1客单价">
                        <el-input
                            readonly
                            style="width: 100%"
                            v-model="MemberInformation.sheetTopAmt1"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="今年目标消费额">
                        <el-input
                            readonly
                            style="width: 100%"
                            v-model="MemberInformation.currTargetAmt"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="Top2客单价">
                        <el-input
                            readonly
                            style="width: 100%"
                            v-model="MemberInformation.sheetTopAmt2"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="今年目标消费次数">
                        <el-input
                            readonly
                            style="width: 100%"
                            v-model="MemberInformation.currTargetSaleTimes"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="Top3客单价">
                        <el-input
                            readonly
                            style="width: 100%"
                            v-model="MemberInformation.sheetTopAmt3"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="VIP消费行为标签">
                        <el-input
                            readonly
                            v-model="MemberInformation.saleTagName"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="平均折扣">
                        <el-input
                            readonly
                            style="width: 100%"
                            v-model="MemberInformation.avgDiscount"
                        ></el-input>
                      </el-form-item>
                    </el-col>

                    <el-col :span="12">
                      <el-form-item>
                        <el-checkbox
                            name="type"
                            disabled
                            label="是否退换货高频"
                            v-model="MemberInformation.isHighRB"
                        ></el-checkbox>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item>
                        <el-checkbox
                            name="type"
                            disabled
                            v-model="MemberInformation.repurchaseWarning"
                            label="开源复购预警"
                            οnclick="return false"
                        ></el-checkbox>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="最近购买日">
                        <el-date-picker
                            style="width: 100%"
                            v-model="MemberInformation.lastSaleDate"
                            type="date"
                        ></el-date-picker>
                      </el-form-item>
                    </el-col>

                    <el-col :span="12">
                      <el-form-item label="购买数量合计">
                        <el-input
                            readonly
                            v-model="MemberInformation.saleAQty"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="最近购买金额">
                        <el-input
                            readonly
                            v-model="MemberInformation.lastSaleAmt"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="最近365天消费额">
                        <el-input
                            readonly
                            v-model="MemberInformation.lastYearAmount"
                        ></el-input>
                      </el-form-item>
                    </el-col>

                    <el-col :span="12">
                      <el-form-item label="去年消费额">
                        <el-input
                            readonly
                            v-model="MemberInformation.prevYearAmount"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="最近12个月消费次数最多门店">
                        <el-input
                            readonly
                            v-model="MemberInformation.yearMaxSaleOrgList"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="去年消费次数合计">
                        <el-input
                            readonly
                            v-model="MemberInformation.prevYearSaleTimes"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="今年维护店消费次数">
                        <el-input
                            readonly
                            v-model="MemberInformation.currYearServSaleTimes"
                        ></el-input>
                      </el-form-item>
                    </el-col>

                    <el-col :span="12">
                      <el-form-item label="购买金额合计">
                        <el-input
                            readonly
                            v-model="MemberInformation.saleAAmount"
                        ></el-input>
                      </el-form-item>
                    </el-col>


                    <el-col :span="12">
                      <el-form-item label="升级后累积消费">
                        <el-input
                            readonly
                            v-model="MemberInformation.lastLvlAmount"
                        ></el-input>
                      </el-form-item>
                    </el-col>

                  </el-row>
                </el-form>
              </div>
            </el-tab-pane>
            <el-tab-pane label="尺码信息" name="five">
              <div style="padding: 0 50px">
                <el-form
                    readonly
                    size="small"
                    label-width="100px"
                    :label-position="labelPosition"
                    :model="MemberInformation"
                >
                  <el-row :gutter="200">
                    <el-col :span="12">
                      <el-form-item label="身高">
                        <el-input
                            readonly
                            v-model="MemberInformation.heightName"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="体重">
                        <el-input
                            readonly
                            v-model="MemberInformation.weightName"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="上衣尺码">
                        <el-input
                            readonly
                            v-model="MemberInformation.topSize"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="下装尺码">
                        <el-input
                            readonly
                            v-model="MemberInformation.bottomSize"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="裙装尺码">
                        <el-input
                            readonly
                            v-model="MemberInformation.skirtSize"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="鞋码">
                        <el-input
                            readonly
                            v-model="MemberInformation.shoeSize"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </div>
            </el-tab-pane>
            <el-tab-pane label="行为偏好" name="six">
              <div style="padding: 0 50px">
                <el-form
                    readonly
                    size="small"
                    label-width="140px"
                    :label-position="labelPosition"
                    :model="MemberInformation"
                >
                  <el-row :gutter="200">
                    <el-col :span="12">
                      <el-form-item label="客户性格类型: 交流">
                        <el-input
                            readonly
                            v-model="MemberInformation.talkativeName"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="客户性格类型: 买单">
                        <el-input
                            readonly
                            v-model="MemberInformation.opionion2Name"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="客户性格类型: 决策">
                        <el-input
                            readonly
                            v-model="MemberInformation.opionionName"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="颜色偏好">
                        <el-input
                            readonly
                            v-model="MemberInformation.colorPreference"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="特殊产品偏好">
                        <textarea
                            name=""
                            id=""
                            rows="6"
                            readonly
                            class="textareaClass"
                            v-model="checkBoxText.ProductHobby"
                        ></textarea>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="客户着衣风格">
                        <textarea
                            name=""
                            id=""
                            rows="6"
                            readonly
                            class="textareaClass"
                            v-model="checkBoxText.DressStyle"
                        ></textarea>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="到店时间偏好">
                        <textarea
                            name=""
                            id=""
                            rows="6"
                            readonly
                            class="textareaClass"
                            v-model="checkBoxText.ArrivalTime"
                        ></textarea>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="奢侈品信息获取渠道">
                        <textarea
                            name=""
                            id=""
                            rows="6"
                            readonly
                            v-model="checkBoxText.AccessToLuxuryInformation"
                            class="textareaClass"
                        ></textarea>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="兴趣爱好">
                        <textarea
                            name=""
                            id=""
                            rows="6"
                            readonly
                            class="textareaClass"
                            v-model="checkBoxText.Hobby"
                        ></textarea>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="邀约敏感点">
                        <textarea
                            name=""
                            id=""
                            rows="6"
                            readonly
                            class="textareaClass"
                            v-model="checkBoxText.InvitationSensitivePoints"
                        ></textarea>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="日常奢侈品购买渠道">
                        <textarea
                            name=""
                            id=""
                            rows="6"
                            readonly
                            class="textareaClass"
                            v-model="checkBoxText.LuxuryPurchaseChannels"
                        ></textarea>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="经常穿着品牌">
                        <textarea
                            name=""
                            id=""
                            rows="6"
                            readonly
                            class="textareaClass"
                            v-model="checkBoxText.OftenWearBrand"
                        ></textarea>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="不良销售记录">
                        <el-input
                            readonly
                            v-model="MemberInformation.badRecord"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="注意点">
                        <el-input
                            readonly
                            v-model="MemberInformation.arriveShopTimeNotes"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="子女情况">
                        <el-input
                            readonly
                            v-model="MemberInformation.hasChild"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="最小子女出生年">
                        <el-input
                            readonly
                            v-model="MemberInformation.childBirthYear"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="宗教信仰">
                        <el-input
                            readonly
                            v-model="MemberInformation.religiousName"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="六小类客户群体">
                        <el-input
                            readonly
                            v-model="MemberInformation.sixTypeName"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="四大客户群体">
                        <el-input
                            readonly
                            v-model="MemberInformation.custGroupName"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="经常穿着品牌备注">
                        <el-input
                            readonly
                            v-model="MemberInformation.preferBrandNotes"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </div>
            </el-tab-pane>
          </el-tabs>
        </el-card>
      </div>
      <!-- 使用封装的组件 -->
      <div class="PagesContentRight">
        <!-- 右侧 相关列表快速链接 RightIndex:页面优化,控制右侧点击选中效果 -->
        <RightCard></RightCard>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { getcpyNo } from "@/utils/auth";
import { GetDetail } from "@/api/viewMemberModule";

export default {
  data() {
    return {
      expiredFlag: false, //该会员是否失效
      busskind: '', //涉及业务
      checkBoxText: {
        MemberTag: "", //会员tag
        ProductHobby: "", //特殊产品爱好
        ArrivalTime: "", //到店时间
        Hobby: "", //兴趣爱好
        LuxuryPurchaseChannels: "", //奢侈品购买渠道
        DressStyle: "", //衣着风格
        AccessToLuxuryInformation: "", //奢侈品信息获取渠道
        InvitationSensitivePoints: "", //邀约敏感点
        OftenWearBrand: "", //经常穿着品牌
        contactInfo: "", //联系方式添加情况
        activityLevel: "", //会员活跃度
      },
      activeName: "first",
      labelPosition: "left",
      // showButton: ''
    };
  },
  created() {
    this.RGetDetail();
    // console.log(this.$route.query.showButton);
  },
  computed: {
    ...mapState({
      custID: (state) => state.user.custID, //勾选的会员ID
      MemberInformation: (state) => state.user.MemberInformation, //会员基本信息
    }),
  },
  methods: {
    RGetDetail() {
      //会员基本信息
      let custID = "";
      if (
          this.$route.query.custID === undefined ||
          this.$route.query.custID === ""
      ) {
        custID = this.custID;
      } else {
        custID = this.$route.query.custID;
      }
      let data = require("qs").stringify({
        //请求参数装换为formData类型
        custID: custID,
        cpyNo: getcpyNo,
      });
      GetDetail(data).then((res) => {
        if (res.success == true) {
          this.expiredFlag = res.data.state !== 0;
          res.data.gender =
              res.data.gender == 2 ? "男" : res.data.gender == 1 ? "女" : "未知";
          res.data.isMillVIP = res.data.isMillVIP == 1 ? true : false;
          res.data.custType = res.data.custType == 1 ? true : false;
          if (res.data.yearMaxSaleOrgList.length > 0) {
            let yearMaxSaleOrgList = "";
            res.data.yearMaxSaleOrgList.forEach((item, index) => {
              if (index >= 0 && index <= 2) {
                yearMaxSaleOrgList += item + ";";
              }
              if (index == 3) {
                yearMaxSaleOrgList += "...";
              }
            });
            res.data.yearMaxSaleOrgList = yearMaxSaleOrgList;
          } else {
            res.data.yearMaxSaleOrgList = "";
          }

          if (res.data.tBussindefineList.length > 0) {
            let busskind = "";
            if(res.data.tBussindefineList.length==1){
              busskind=res.data.tBussindefineList[0].bussnameCn;
            }else {
              res.data.tBussindefineList.forEach((item) => {
                busskind += item.bussnameCn + ";";
              });
            }
            this.busskind = busskind;
          }
          for (const key in res.select) {
            res.select[key].forEach((item) => {
              //格式化textarea中的类型
              if (key == 10) {
                //顾客偏好产品定义
                this.checkBoxText.ProductHobby += item.description_CN + "\n";
              }
              if (key == 13) {
                //顾客标签（会员TAG）
                this.checkBoxText.MemberTag += item.description_CN + "\n";
              }
              if (key == 14) {
                //顾客到店时间偏好定义
                this.checkBoxText.ArrivalTime += item.description_CN + "\n";
              }
              if (key == 15) {
                //顾客着衣风格定义
                this.checkBoxText.DressStyle += item.description_CN + "\n";
              }
              if (key == 24) {
                //顾客邀约敏感点
                this.checkBoxText.InvitationSensitivePoints +=
                    item.description_CN + "\n";
              }
              if (key == 25) {
                //顾客兴趣爱好
                this.checkBoxText.Hobby += item.description_CN + "\n";
              }
              if (key == 26) {
                //顾客经常穿着品牌
                this.checkBoxText.OftenWearBrand += item.description_CN + "\n";
              }
              if (key == 27) {
                //顾客日常奢侈品购买渠道
                this.checkBoxText.LuxuryPurchaseChannels +=
                    item.description_CN + "\n";
              }
              if (key == 28) {
                //顾客奢侈品信息获取渠道
                this.checkBoxText.AccessToLuxuryInformation +=
                    item.description_CN + "\n";
              }
              if (key == 36) {
                //联系方式添加情况
                this.checkBoxText.contactInfo +=
                    item.description_CN + "\n";
              }
              if (key == -2) {
                //会员活跃度
                this.checkBoxText.activityLevel +=
                    item.description_CN + "\n";
              }
            });
          }
          //  for (const key in res.data) {    //暂无数据提示
          //   if (res.data[key] == null || res.data[key].length <= 0) {
          //     res.data[key] = "暂无数据";
          //   }
          // }z
          this.$store.dispatch("user/UpGetMemberInformation", res.data); //保存基本会员信息到vuex
          localStorage.setItem("MemberInformation", JSON.stringify(res.data)); //保存基本会员信息到本地(防止用户刷新网页,清空vuex数据)
        } else {
          this.$message.error(res.message);
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.NumberCardWidth {
  width: 1265px;
}
.header-centers {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 10px;
  padding-bottom: 100px;
  .left-member-box {
    position: relative;
    .expired-img {
      position: absolute;
      left: 0;
      top: 0;
      width: 70px;
      height: 70px;
    }
  }
}

.PagesContentRight {
  margin-left: 25px;
  height: 990px;
  display: flex;
  flex-direction: column;
  justify-self: flex-start;
  align-content: flex-start;
}
.textareaClass {
  width: 100%;
  padding: 3px 12px;
  font-size: 12px;
  line-height: 18px;
  resize: none;
}
.DisableDiv {
  display: flex;
  width: 100%;
  height: 30px;
  line-height: 30px;
  border: 1px solid #797979;
  background-color: #f2f2f2;
  font-size: 17px;
  color: #000000;
  padding: 0 10px;
}
.look-member {
  width: 100%;
  height: 100%;
}
.push-button {
  background-color: #e9e7d3;
}

// 按钮边框去掉，文字颜色和加粗
/deep/button {
  border-color: #e6e0af;
  border-radius: 7px;
  color: #a19b59;
}
/deep/input {
  border-radius: 0 !important;
}
::v-deep {
  .el-tabs__item.is-active {
    color: #a19b5a !important;
    // color: red !important;
  }

  .el-tabs__item:hover {
    color: #333;
  }
  .el-tabs__active-bar {
    height: 0;
  }

  .el-form--label-top .el-form-item__label {
    padding: 0;
  }
  .el-form-item__content {
    line-height: 0px;
  }
}
</style>
